import FeatureGates from '@atlaskit/feature-gate-js-client';

import { COHORT_PARAMETER, Cohort, DEFAULT_VALID_EXPERIMENT_COHORTS, NOT_ENROLLED, VARIATION } from './cohorts';
import { type ExperimentNames } from './experiment-keys';

/**
 * @deprecated Please use expVal instead.
 * For context see https://hello.atlassian.net/wiki/spaces/STATUS/pages/5931337789/RFC+We+should+align+on+standard+feature+gating+and+experiment+patterns+in+Townsquare
 */
export const useIsExperimentEnabled = (
	experimentName: ExperimentNames,
	variantKey: Cohort = VARIATION,
	validExperimentCohorts: Cohort[] = DEFAULT_VALID_EXPERIMENT_COHORTS,
	fireExperimentExposure = true,
) => {
	if (FeatureGates.initializeCalled()) {
		const cohort = FeatureGates.getExperimentValue(experimentName, COHORT_PARAMETER, NOT_ENROLLED, {
			fireExperimentExposure,
		}) as Cohort;
		const isValid = typeof cohort === 'string' && validExperimentCohorts.includes(cohort);
		return (isValid ? cohort : NOT_ENROLLED) === variantKey;
	}

	return false;
};

/**
 * @deprecated Please use expVal instead.
 * For context see https://hello.atlassian.net/wiki/spaces/STATUS/pages/5931337789/RFC+We+should+align+on+standard+feature+gating+and+experiment+patterns+in+Townsquare
 *
 * Duplicate of useIsExperimentEnabled defined such that it can be used outside of a React hook.
 */
export const getIsExperimentEnabled = (
	experimentName: ExperimentNames,
	variantKey: Cohort = VARIATION,
	validExperimentCohorts: Cohort[] = DEFAULT_VALID_EXPERIMENT_COHORTS,
	fireExperimentExposure = true,
) => {
	if (FeatureGates.initializeCalled()) {
		const cohort = FeatureGates.getExperimentValue(experimentName, COHORT_PARAMETER, NOT_ENROLLED, {
			fireExperimentExposure,
		}) as Cohort;
		const isValid = typeof cohort === 'string' && validExperimentCohorts.includes(cohort);
		return (isValid ? cohort : NOT_ENROLLED) === variantKey;
	}

	return false;
};

/**
 * @deprecated Please use expVal instead
 * For context see https://hello.atlassian.net/wiki/spaces/STATUS/pages/5931337789/RFC+We+should+align+on+standard+feature+gating+and+experiment+patterns+in+Townsquare
 *
 * Duplicate of useIsExperimentEnabledWithoutExposure defined such that it can be used outside of a React hook.
 */
export const getIsExperimentEnabledWithoutExposure = (
	experimentName: ExperimentNames,
	variantKey: Cohort = VARIATION,
	validExperimentCohorts: Cohort[] = DEFAULT_VALID_EXPERIMENT_COHORTS,
) => getIsExperimentEnabled(experimentName, variantKey, validExperimentCohorts, false);

/**
 * @deprecated Please avoid manual exposure logging, use of expVal in place of hooks should help.
 * For context see https://hello.atlassian.net/wiki/spaces/STATUS/pages/5931337789/RFC+We+should+align+on+standard+feature+gating+and+experiment+patterns+in+Townsquare
 */
export const manuallyLogExperimentExposure = (experimentName: ExperimentNames) =>
	FeatureGates.manuallyLogExperimentExposure(experimentName);

type AssurePrimitives<T> = T extends string ? string : T extends number ? number : T extends boolean ? boolean : T;

export function expVal<T>(experimentName: ExperimentNames, param: string, defaultValue: T): AssurePrimitives<T> {
	const value = FeatureGates.getExperimentValue(experimentName, param, defaultValue);

	return value as AssurePrimitives<T>;
}
